import axios from "axios";
import notify from "devextreme/ui/notify";

export const ME_TYPE = "ME_TYPE";

export function receiveMeSuccess(me) {
    return {
        type: ME_TYPE,
        reduce: state => ({
            ...state,
            me: me,
        })
    };
}

export function receiveMeFail() {
    return {
        type: ME_TYPE,
        reduce: state => ({
            ...state,
            me: null
        })
    };
}

function getMeQuery(dispatch) {
    return axios
        .get("/work/api/me", {
            headers: {
                Accept: "application/json"
            }
        }).then(response => {
            dispatch(receiveMeSuccess(response.data));
        })
        .catch(error => {
            notify(
                {
                    closeOnClick: true,
                    closeOnOutsideClick: true,
                    message: "Не удалось загрузить данные пользователя"
                },
                "error"
            );
            dispatch(receiveMeFail());
        });
}

function postAvatarQuery(file) {
    let logoUrl = "/work/api/me/avatar";
    let formData = new FormData();
    formData.append("avatar", file, file.name);
    return axios.post(logoUrl, formData, {
        headers: {
            'Accept': 'application/json'
        },
    });

}

export function loadMe() {
    return (dispatch) => {
        return getMeQuery(dispatch);
    };
}

export function setAvatar(file) {
    return (dispatch) => {
        return postAvatarQuery(file)
            .then(() => {
                return getMeQuery(dispatch);
            })
            .catch(error => {
                notify(
                    {
                        closeOnClick: true,
                        closeOnOutsideClick: true,
                        message: "Не удалось установить аватар пользователя"
                    },
                    "error"
                );
            });
    }
}
